import React from "react";
import { RouteObject } from "react-router-dom";

import { GENERAL_ROUTES } from "../../routes";

export const ReverseProxyTestRoutes: RouteObject[] = [
  {
    path: GENERAL_ROUTES.ReverseProxyTest,
    lazy: async () => {
      const { ReverseProxyTestRoute } =
        await import("@src/domains/ReverseProxyTest/ReverseProxyTest.route");
      return {
        element: <ReverseProxyTestRoute />,
      };
    },
  },
];
